import React, { useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import './RegisterBet.scss';
import Icon from 'src/components/Icon/Icon';

interface RegisterBetProps {
  onClick?: () => void,
  onLoadBet?: () => void
}

function RegisterBet({ onClick, onLoadBet }: RegisterBetProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleOnClick = (e) => {
    e.stopPropagation();
    onClick();
  };

  const handleOnLoadBet = (e) => {
    e.stopPropagation();
    onLoadBet();
  };

  return (
    <>
      <div
        className="register-bet"
        onClick={ () => setOpen(!open) }
      >
        <div
          className="register-bet__title"
          onClick={ handleOnClick }
        >
          { t('betslip.registerBets') }
        </div>
        <Icon
          icon="arrow"
          className={
            classNames(
              'register-bet__arrow',
              { 'register-bet__arrow--open': open }
            )
          }
        />
      </div>
      {
        open && (
          <div
            onClick={ handleOnLoadBet }
            className="register-bet__load-bets"
          >
            { t('betslip.loadBets') }
          </div>
        )
      }
    </>
  );
}

export default RegisterBet;
